import { render, staticRenderFns } from "./DetalharUsoFuncaoDialog.vue?vue&type=template&id=99325876&scoped=true"
import script from "./DetalharUsoFuncaoDialog.vue?vue&type=script&lang=js"
export * from "./DetalharUsoFuncaoDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalharUsoFuncaoDialog.vue?vue&type=style&index=0&id=99325876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99325876",
  null
  
)

export default component.exports